import {
  Component,
  OnInit,
  Input,
  ElementRef,
  AfterViewInit,
  forwardRef,
  InjectionToken,
  ChangeDetectorRef,
  Renderer2,
  ViewChild,
  OnDestroy,
  NgZone,
  HostListener,
  ComponentFactoryResolver,
  ChangeDetectionStrategy,
  TemplateRef,
  HostBinding,
  Output,
  EventEmitter
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd';
import { ContextMenuComponent, IContextMenuClickEvent, ContextMenuService } from 'ngx-contextmenu';
import {
  NgxExcelColumnType,
  NgxExcelComponentState,
  NgxExcelColumn,
  NgxExcelRow,
  NgxExcelAction,
  NgxExcelActionScope,
  NgxExcelContextMenuClickedEvent,
  // NgxExcelContextChanged,
  NgxExcelContextChangeRecord
} from '../../models/models';
import { NgxExcelController } from '../../services/services';
import { Observable, of, Subscription, fromEvent, Subject } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, catchError, filter, tap, share } from 'rxjs/operators';

interface NgxExcelAnchorItem {
  index: number;
  offset: number;
}

export const NgxExcelComponentRef = new InjectionToken<NgxExcelComponent>('NgxExcelComponent');

@Component({
  selector: 'ngx-excel',
  templateUrl: './ngx-excel.component.html',
  providers: [
    NgxExcelController,
    { provide: NgxExcelComponentRef, useExisting: forwardRef(() => NgxExcelComponent) }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NgxExcelComponent implements OnInit, OnDestroy, AfterViewInit {

  componentStateEnums: typeof NgxExcelComponentState = NgxExcelComponentState;
  componentState: NgxExcelComponentState = this.componentStateEnums.Initial;
  toggleColumnEnabled = false;
  decorativeCol: NgxExcelColumn;
  lineHeight = 40;
  excelCols: NgxExcelColumn[] = [];
  excelRows: NgxExcelRow[] = [];
  loadedCount = 0;
  total = 0;
  attachedItemBegin = 0;
  attachedItemEnd = 0;

  scrollBarYWidth = 18;
  scrollBarXHeight = 15;
  excelRowsReflection: { [name: string]: number } = {};       // è¡åå°
  excelPrefixActions: NgxExcelAction[] = [];
  excelGlobalActions: NgxExcelAction[] = [];
  excelContextActions: NgxExcelAction[] = [];
  excelColumnActions: NgxExcelAction[] = [];

  protected excelAnchorItem: NgxExcelAnchorItem = { index: 0, offset: 0 };
  protected excelScreenItem: NgxExcelAnchorItem = { index: 0, offset: 0 };

  protected excelAnchorScrollTop = 0;
  protected excelAnchorScrollRunwayEnd = 0;

  private _cacheKey = '';
  private _readonly = false;
  private _lazyload = false;
  private _scrollable = true;
  private _invisibleColumns: string[] = [];
  private _el: HTMLElement = null;
  private _headEl: HTMLElement = null;
  private _bodyEl: HTMLElement = null;
  private _footEl: HTMLElement = null;
  private _scrollBarXEl: HTMLElement = null;
  private _scrollBarXScrolling = false;
  private _scrollBarXRatio = 0;
  private _excelScrolling = false;
  private _componentSubscription = new Subscription();

  @Input()
  set readonly(value: boolean) { this._readonly = value === false ? false : true; }
  get readonly(): boolean { return this._readonly; }

  @Input()
  set lazyload(value: boolean) { this._lazyload = value === false ? false : true; }
  get lazyload(): boolean { return this._lazyload; }

  @Input()
  set scrollable(value: boolean) { this._scrollable = value === false ? false : true; }
  get scrollable(): boolean { return this._scrollable; }

  @Input() cellHeight: number;
  @Input()
  set name(value: string) {
    if (!value && value.length === 0) { return; }
    this._cacheKey = value.indexOf('excel') === 0 ? value : ('excel_' + value);
    this.toggleColumnEnabled = true;
  }
  @Input() customTemplate: TemplateRef<{ $implicit: any }>;
  @Input() customCalculateHeight: (context: any) => number;

  @Input() dataSet: any[];
  @Output() dataSetChange = new EventEmitter<any[]>();

  @ViewChild(ContextMenuComponent, { static: false }) protected contextMenuComponent: ContextMenuComponent;

  @HostBinding('class.custom') customClass: boolean;
  @HostListener('contextmenu', ['$event']) onContextMenu(e: MouseEvent) {
    if (!this.contextMenuComponent) { return; }
    this.contextMenu.show.next({
      contextMenu: this.contextMenuComponent,
      event: e,
      item: { context: null, column: null }
    });
    e.preventDefault();
    e.stopPropagation();
  }

  constructor(
    protected el: ElementRef,
    protected renderer2: Renderer2,
    protected cfr: ComponentFactoryResolver,
    protected cdr: ChangeDetectorRef,
    protected ngZone: NgZone,
    protected httpClient: HttpClient,
    protected message: NzMessageService,
    protected contextMenu: ContextMenuService,
    public controller: NgxExcelController
  ) { }

  ngOnInit() {
    // é»è®¤çå¥æå
    this.decorativeCol = {
      name: '', label: '', tooltip: null, index: 0,
      width: 6, computedWidth: 6, computedOffset: 0,
      locked: true, readonly: true, invisible: false, sortable: false,
      columnType: NgxExcelColumnType.Text, allowNegative: false,
      selectOptions: [], relativeService: null, labelKey: 'label', typeaheadKey: '', disableCache: true,
      acceptedFileType: '', acceptedFileSize: 0, acceptedFileCount: 1, acceptedSelectedCount: 0, acceptedWordCount: 0,
      template: null, templateEdit: null, templateHead: null, onClickedCallback: null
    };
    this.customClass = !!this.customTemplate;
    this.lineHeight = Math.max(typeof (this.cellHeight) === 'string' ? parseInt(this.cellHeight, 0) : this.cellHeight || 40, 40);
    this._invisibleColumns = this._getInvisibleColumns();
    if (this.dataSet) {
      this.controller.bindDataSet(this.dataSet);
    }
  }

  ngOnDestroy() {
    this._componentSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    // this.excelWrapperEl = this.wrapperSelector ? document.querySelector(this.wrapperSelector) : this.el.nativeElement;
    this._el = this.el.nativeElement.querySelector('.excel');
    this._headEl = this.el.nativeElement.querySelector('.excel-head');
    this._bodyEl = this.el.nativeElement.querySelector('.excel-body');
    this._footEl = this.el.nativeElement.querySelector('.excel-foot');
    this._scrollBarXEl = this.el.nativeElement.querySelector('.excel-foot .scrollbar-x');

    if (this._lazyload) {
      this.componentState = this.componentStateEnums.Normal;
    }

    this._listenNativeEvents();
    this.rebuildUi();
  }

  /**
   * åè½¬åæ¾ç¤º
   * @param _ èåç¹å»äºä»¶
   * @param column å³èçè¡¨æ ¼å
   */
  handleColumnToggle(_: IContextMenuClickEvent, column: NgxExcelColumn) {
    column.invisible = !column.invisible;
    if (column.name.length > 0) {
      if (column.invisible) {
        this._invisibleColumns.push(column.name);
      } else {
        this._invisibleColumns = this._invisibleColumns.filter((invisibleColumn) => invisibleColumn !== column.name);
      }
      this._cacheInvisibleColumns();
    }
    this.rebuildUi();
  }

  /**
   * å½èåè¢«ç¹å»æ¶æ§è¡
   * @param _ èåç¹å»äºä»¶æºå¸¦å½åæä½çä¸ä¸æ
   * @param action å³èçæä½å¨ä½
   */
  handleContextMenuClick(_: IContextMenuClickEvent, action: NgxExcelAction) {
    const payload = _.item as NgxExcelContextMenuClickedEvent;
    payload.action = action;

    let resultCallback: Observable<NgxExcelContextChangeRecord[]>;
    let innerCall = true;

    if (payload.action.execute) {
      // å®ä¹äº execute å±æ§ç± Component æ¥ç®¡
      resultCallback = payload.action.execute(payload) || null;
      innerCall = false;
    } else {
      // å®ä¹äº payload.action.action æ¹æ³ç± Service æ¥ç®¡
      // resultCallback = payload.action.actionScope === NgxExcelActionScope.Excel ?
      // this.controller.handleContextMenuClick(payload.action.action) :
      // this.controller.handleContextMenuClick(payload.action.action, payload.context);
      resultCallback = this.controller.handleContextMenuClick(payload.action.action, payload.context);
    }

    if (!resultCallback) { return; }

    const componentState = this.componentState;
    if (innerCall) {
      this.componentState = this.componentStateEnums.Loading;
    }
    resultCallback.subscribe((changedContexts) => {
      if (innerCall) { this.componentState = componentState; }
      if (payload.action.actionScope === NgxExcelActionScope.Excel) {
        this.handleChangedContexts(changedContexts);
      } else {
        this.handleChangedContexts(changedContexts, payload.context);
      }
    }, (err) => {
      this._getErrorHandles()(err);
      if (innerCall) {
        this.componentState = componentState;
      }
    });
  }

  /**
   * æ¹éå¤çä¸ä¸ææ¨¡ååæ´
   * @param records åæ´è®°å½
   * @param relativeContext ç¸å³çä¸ä¸ææ¨¡å
   */
  public handleContextChange(records: NgxExcelContextChangeRecord[], relativeContext?: any) {
    let reloadSignal = false;
    records.forEach((record) => {
      if (record.action === 'updated' || record.action === 'update') {
        this.updateContexts(
          record.contexts || [record.context],
          record.relativeContext || relativeContext,
          true
        );
        this.cdr.detectChanges();
      } else if (record.action === 'append' || record.action === 'prepend') {
        this.appendContexts(
          record.contexts || [record.context],
          record.relativeContext || relativeContext,
          true,
          record.action === 'prepend'
        );
        reloadSignal = true;
      } else if (record.action === 'removed' || record.action === 'remove') {
        this.removeContexts(record.contexts || [record.context], true);
        reloadSignal = true;
      }
    });

    this.dataSetChange.emit(this.controller.getDataSet());
    if (!reloadSignal) { return; }
    if (this.dataSet) {
      this._handleExcelScroll();
    } else {
      this.reload();
    }
  }

  /**
   * æ´æ°ä¸ä¸ææ¨¡å
   * @param contexts æææ´æ°çä¸ä¸ææ¨¡ååè¡¨
   * @param relativeContext ç¸å³çä¸ä¸ææ¨¡å
   * @param isQuiet éé»æä½
   */
  public updateContexts(contexts: any[], relativeContext?: any, isQuiet?: boolean) {
    const relativePrimaryKey = relativeContext ? this.controller.getPrimaryKey(relativeContext) : null;
    contexts.forEach((context) => {
      const primaryKey = this.controller.getPrimaryKey(context);
      const index = this.excelRowsReflection[relativePrimaryKey || primaryKey];
      if (index === null || index === undefined) { return; }
      this.excelRowsReflection[primaryKey] = index;
      if (relativePrimaryKey && relativePrimaryKey !== primaryKey) {
        delete this.excelRowsReflection[relativePrimaryKey];
      }

      if (this.customCalculateHeight) {
        const prevRowHeight = this.customCalculateHeight(this.excelRows[index].context);
        const currRowHeight = this.customCalculateHeight(context);
        this.excelAnchorScrollRunwayEnd = this.excelAnchorScrollRunwayEnd - prevRowHeight + currRowHeight;
      }

      this.excelRows[index].primaryKey = primaryKey;
      this.excelRows[index].context = Object.assign({}, context);

      // éè¦åæ­¥ä¿®æ¹æ°æ®é
      if (this.dataSet) {
        this.dataSet.splice(index, 1, context);
      }
    });

    if (!isQuiet) {
      this.dataSetChange.emit(this.controller.getDataSet());
      this.cdr.detectChanges();
    }
  }

  /**
   * æ°å¢ä¸ä¸ææ¨¡å
   * @param contexts æææ°å¢çä¸ä¸ææ¨¡ååè¡¨
   * @param relativeContext ç¸å³çä¸ä¸ææ¨¡å
   * @param isQuiet éé»æä½
   * @param prepend æ¯å¦ååæ°å¢
   */
  public appendContexts(contexts: any[], relativeContext?: any, isQuiet?: boolean, prepend?: boolean) {
    if (this.dataSet) {
      let index: number;
      let beginIndex: number;
      let beginY: number;
      if (relativeContext) {
        const primaryKey = this.controller.getPrimaryKey(relativeContext);
        index = this.excelRowsReflection[primaryKey];
      } else if (prepend) {
        index = 0;
      } else {
        index = this.excelRows.length - 1;
      }

      if (prepend) {
        beginIndex = Math.max(index, 0);
        beginY = (beginIndex >= this.excelRows.length) ? 0 : this.excelRows[beginIndex].y;
      } else {
        beginIndex = Math.max(index + 1, 0);
        beginY = (beginIndex >= this.excelRows.length) ? (
          (index < 0) ? 0 : (this.excelRows[index].h + this.excelRows[index].y)
        ) : this.excelRows[beginIndex].y;
      }
      let appendRowsHeight = 0;
      const excelRows = contexts.map((context, i) => {
        const excelRow = this.controller.createExcelRow(null, beginIndex + i);
        excelRow.context = Object.assign({}, context);
        excelRow.primaryKey = this.controller.getPrimaryKey(context);
        excelRow.y = beginY + appendRowsHeight;
        excelRow.h = this.customCalculateHeight ? this.customCalculateHeight(context) : this.lineHeight;
        appendRowsHeight += excelRow.h;
        this.excelRowsReflection[excelRow.primaryKey] = beginIndex + i;
        return excelRow;
      });

      // ä¿®æ¹è¡åææè¡çä½ç½®ç´¢å¼
      for (let i = beginIndex; i < this.excelRows.length; i++) {
        this.excelRows[i].y += appendRowsHeight;
        const excelRowPrimaryKey = this.excelRows[i].primaryKey;
        const excelRowIndex = this.excelRowsReflection[excelRowPrimaryKey];
        if (excelRowIndex !== null && excelRowIndex !== undefined) {
          this.excelRowsReflection[excelRowPrimaryKey] = excelRowIndex + excelRows.length;
        }
      }

      // æå¥è¡å¹¶æ´æ°ç»è®¡ä¿¡æ¯
      this.excelRows.splice(beginIndex, 0, ...excelRows);
      this.loadedCount += excelRows.length;
      this.total += excelRows.length;
      this.excelAnchorScrollRunwayEnd += appendRowsHeight;

      // åæ­¥ä¿®æ¹æ°æ®é
      this.dataSet.splice(beginIndex, 0, ...contexts);

      if (!isQuiet) {
        this.dataSetChange.emit(this.controller.getDataSet());
        this._handleExcelScroll();
      }
    } else {
      if (!isQuiet) {
        this.dataSetChange.emit(this.controller.getDataSet());
        this.reload();
      }
    }
  }

  /**
   * ååæ°å¢ä¸ä¸ææ¨¡å
   * @param contexts æææ°å¢çä¸ä¸ææ¨¡ååè¡¨
   * @param relativeContext ç¸å³çä¸ä¸ææ¨¡å
   * @param isQuiet éé»æä½
   */
  public prependContexts(contexts: any[], relativeContext?: any, isQuiet?: boolean) {
    this.appendContexts(contexts, relativeContext, isQuiet, true);
  }

  /**
   * å é¤ä¸ä¸ææ¨¡å
   * @param contexts ææå é¤çä¸ä¸ææ¨¡ååè¡¨
   * @param isQuiet éé»æä½
   */
  public removeContexts(contexts: any[], isQuiet?: boolean) {
    if (this.dataSet) {
      let removedRowCount = 0;
      let removedRowsHeight = 0;
      contexts.forEach((context) => {
        const primaryKey = this.controller.getPrimaryKey(context);
        const index = this.excelRowsReflection[primaryKey];
        if (index === null || index === undefined) { return; }
        delete this.excelRowsReflection[primaryKey];
        const currentRowHeight = this.customCalculateHeight ? this.customCalculateHeight(this.excelRows[index].context) : this.lineHeight;
        removedRowsHeight += currentRowHeight;

        // ä¿®æ¹è¡åææè¡çä½ç½®ç´¢å¼
        for (let i = index + 1; i < this.excelRows.length; i++) {
          this.excelRows[i].y -= currentRowHeight;
          const excelRowPrimaryKey = this.excelRows[i].primaryKey;
          const excelRowIndex = this.excelRowsReflection[excelRowPrimaryKey];
          if (excelRowIndex !== null && excelRowIndex !== undefined) {
            this.excelRowsReflection[excelRowPrimaryKey] = Math.max(0, excelRowIndex - 1);
          }
        }
        // å é¤è¡
        this.excelRows.splice(index, 1);
        this.dataSet.splice(index, 1);
        removedRowCount++;
      });

      // æ´æ°ç»è®¡ä¿¡æ¯
      this.loadedCount -= removedRowCount;
      this.total -= removedRowCount;
      this.excelAnchorScrollRunwayEnd -= removedRowsHeight;

      if (!isQuiet) {
        this.dataSetChange.emit(this.controller.getDataSet());
        this._handleExcelScroll();
      }
    } else {
      if (!isQuiet) {
        this.dataSetChange.emit(this.controller.getDataSet());
        this.reload();
      }
    }
  }

  /**
   * å½ä¸ä¸æåçååæ¶æ§è¡
   * @param records ä¸ä¸æåæ´è®°å½åè¡¨
   * @param relativeContext ç¸å³çä¸ä¸æ
   */
  public handleChangedContexts(records: NgxExcelContextChangeRecord[], relativeContext?: any) {
    this.handleContextChange(records, relativeContext);
  }

  /**
   * éæ°å è½½æ°æ®
   */
  public reload() {
    if (this.componentState === this.componentStateEnums.Initial || this.componentState === this.componentStateEnums.Loading) { return; }

    this.componentState = this.componentStateEnums.Initial;
    if (!this.dataSet) {
      // å¨ææ°æ®æºæéæ¾ç¤ºå è½½æç¤º
      this.message.loading('æ°æ®å è½½ä¸­ï¼è¯·ç¨å...', { nzDuration: 0 });
    }

    this.excelRows = [];
    this.total = 0;
    this.loadedCount = 0;
    this.excelAnchorScrollRunwayEnd = 0;
    this._el.scrollTop = 0;
    this._el.scrollLeft = 0;

    this._loadRows().subscribe(() => this._handleExcelScroll());
  }

  /**
   * è®¾ç½® Excel è¿å¥ loading ç¶æ
   */
  public loading() {
    if (this.componentState === this.componentStateEnums.Initial || this.componentState === this.componentStateEnums.Loading) { return; }
    this.componentState = this.componentStateEnums.Loading;
    if (this.dataSet) { return; }
    // å¨ææ°æ®æºæéæ¾ç¤ºå è½½æç¤º
    this.message.loading('æ°æ®å è½½ä¸­ï¼è¯·ç¨å...', { nzDuration: 0 });
  }

  /**
   * è®¾ç½® Excel è¿å¥ normal ç¶æ
   */
  public normal() {
    this.componentState = this.componentStateEnums.Normal;
    if (this.dataSet) { return; }
    this.message.remove();
  }

  /**
   * éå»ºUI
   */
  public rebuildUi() {
    // èªå®ä¹åå®¹æ¨¡æ¿çæåµä¸, ä¸åæ¾ç¤ºè¡¨å¤´ä¸æ éåè®¡ç®å®½åº¦
    if (!this.customTemplate) {
      const excelWidth = parseInt(getComputedStyle(this.el.nativeElement, null).width, 10);
      // å®ä¹ä¸ºä¸å¯æ»å¨æ¶æ éåå»çºµåæ»å¨æ¡çå®½åº¦
      const componentWidth = excelWidth - this.decorativeCol.width - (this.scrollable ? this.scrollBarYWidth : 0);
      const expectedColumnsWidth = this.excelCols.filter((col) => !col.invisible)
        .map((col) => col.width)
        .reduce((previous, current) => previous + current, 0);

      let computedComponentWidth = 0;
      if (!this.scrollable || expectedColumnsWidth < componentWidth) {
        // å®½åº¦è¡¥é½
        this.excelCols.forEach((col, index) => {
          if (col.invisible) { return; }
          col.computedOffset = computedComponentWidth + this.decorativeCol.width;
          if (index === this.excelCols.length - 1) {
            // æåä¸å
            col.computedWidth = componentWidth - computedComponentWidth;
            computedComponentWidth = componentWidth;
          } else {
            // å¶ä»å
            col.computedWidth = Math.floor(componentWidth * col.width / expectedColumnsWidth);
            computedComponentWidth += col.computedWidth;
          }
        });
      } else {
        // å®½åº¦æº¢åº
        this.excelCols.forEach((col) => {
          if (col.invisible) { return; }
          col.computedWidth = col.width;
          col.computedOffset = computedComponentWidth + this.decorativeCol.width;
          computedComponentWidth += col.computedWidth;
        });
      }

      this.cdr.detectChanges();

      const finalComponentWidth = computedComponentWidth + this.decorativeCol.width;
      this.renderer2.setStyle(this._headEl, 'width', `${finalComponentWidth}px`);
      this.renderer2.setStyle(this._bodyEl, 'width', `${finalComponentWidth}px`);

      // æ»å¨æ¡å®½åº¦è®¡ç®
      if (this._scrollBarXEl) {
        const scrollBarOuterWidth = parseInt(getComputedStyle(this._scrollBarXEl, null).width, 10);
        this._scrollBarXRatio = Math.round(scrollBarOuterWidth / excelWidth * 10000) / 10000;
        const scrollBarWidth = Math.ceil(finalComponentWidth * this._scrollBarXRatio);
        this.renderer2.setStyle(this._scrollBarXEl.querySelector('span'), 'width', `${scrollBarWidth}px`);
      }
    }

    if (this._lazyload) { return; }
    if (this.componentState === this.componentStateEnums.Initial) {
      this._loadRows().subscribe(() => this._handleExcelScroll());
    } else {
      this._handleExcelScroll();
    }
  }

  /**
   * å¢å è¡¨æ ¼å
   * @param column åå®ä¹
   */
  public appendColumn(column: NgxExcelColumn, index: number = -1) {
    const excelCol = this.controller.resolveColumn(column);
    if (!excelCol) {
      this._getErrorHandles()({ message: 'è¡¨æ ¼åå®ä¹éè¯¯' });
      return;
    }

    excelCol.computedWidth = excelCol.width;
    excelCol.computedOffset = 0;

    // ééå®åå¹¶ä¸éç½®äºéèååä¸è¦æ¾ç¤ºå
    if (!excelCol.locked && !excelCol.invisible) {
      excelCol.invisible = this._invisibleColumns.indexOf(excelCol.name) >= 0;
    }

    // è¡¨æ ¼åªè¯»çæ¶ååæ¶ç¼è¾æ¨¡å¼çéç½®
    if (this._readonly) {
      excelCol.readonly = true;
      excelCol.templateEdit = null;
    }

    // éå®åå¿é¡»è¿ç»­
    if (index >= 0) {
      excelCol.locked = excelCol.locked && !this.excelCols.slice(0, index).some((col) => !col.locked);
      this.excelCols.splice(index, 0, excelCol);
    } else {
      excelCol.locked = excelCol.locked && !this.excelCols.some((col) => !col.locked);
      this.excelCols.push(excelCol);
    }

    this.excelCols = this.excelCols.sort((column1, column2) => {
      if (column1.locked === column2.locked) {
        return column1.index - column2.index;
      }
      return column1.locked ? -1 : 1;
    });

    if (this.componentState === this.componentStateEnums.Initial) { return; }
    try { this.rebuildUi(); } catch (_) { }
  }

  /**
   * å é¤è¡¨æ ¼å
   * @param name ååç§°
   */
  public removeColumn(name: string) {
    const index = this.excelCols.findIndex((col) => col.name === name);
    if (index < 0) { return; }
    this.excelCols.splice(index, 1);
    if (this.componentState === this.componentStateEnums.Initial) { return; }
    try { this.rebuildUi(); } catch (_) { }
  }

  /**
   * å¢å è¡¨æ ¼æä½é¡¹
   * @param action æä½é¡¹å®ä¹
   */
  public addExcelAction(action: NgxExcelAction) {
    if (action.invisible) {
      action.visible = () => false;
    } else {
      action.visible = ({ context, column }) => {
        if (action.actionScope === NgxExcelActionScope.Column && (!context || !column)) {
          return false;
        }
        if (action.actionScope === NgxExcelActionScope.Context && !context) {
          return false;
        }
        return this.controller.privilege(context, action.action);
      };
    }

    if (action.disabled) {
      action.enabled = () => false;
    } else {
      action.enabled = ({ context, column }) => {
        if (action.actionScope === NgxExcelActionScope.Column && (!context || !column)) {
          return false;
        }
        if (action.actionScope === NgxExcelActionScope.Context && !context) {
          return false;
        }
        return this.controller.can(context, action.action);
      };
    }

    switch (action.actionScope) {
      case NgxExcelActionScope.Excel:
        if (action.prefix) {
          this.excelPrefixActions.push(action);
        } else {
          this.excelGlobalActions.push(action);
        }
        break;
      case NgxExcelActionScope.Context:
        this.excelContextActions.push(action);
        break;
      case NgxExcelActionScope.Column:
        this.excelContextActions.push(action);
        break;
    }
  }

  /**
   * è·å¾ä¸ä¸æèå
   */
  public getContextMenuComponent(): ContextMenuComponent {
    // èªå®ä¹åå®¹æ¶ç¦ç¨èåé¡¹
    return this.customTemplate ? null : this.contextMenuComponent;
  }

  /**
   * ç»å®æç´¢æ¡ä»¶
   * @param filters å¨å±æç´¢æ¡ä»¶
   */
  public bindFilters(filters: { [param: string]: string | string[] }): NgxExcelComponent {
    this.controller.bindFilters(filters);
    return this;
  }

  /**
   * ç»å®å¨å±åæ°æ®è¯·æ±å­æ®µ
   * @param metas å¨å±åæ°æ®è¯·æ±å­æ®µ
   */
  public bindMetas(metas: string | string[]): Observable<{ [name: string]: any }> {
    return this.controller.bindMetas(metas);
  }

  /**
   * å¡«ååå®¹ï¼å¦æéè¦çè¯æ´æ°æ»å¨æ¡çä½ç½®
   */
  protected attachContent() {
    const begin = Math.max(0, this.attachedItemBegin - 25);
    const end = Math.min(this.total, this.attachedItemEnd + 25);
    for (let i = 0; i < this.excelRows.length; i++) {
      if (i < begin || i > end) {
        this.excelRows[i].visible = false;
        continue;
      }
      this.excelRows[i].visible = true;
    }
    this.renderer2.setStyle(this._bodyEl, 'height', `${this.excelAnchorScrollRunwayEnd}px`);
    try {
      this.cdr.detectChanges();
      this._loadRows().subscribe((signal) => signal && this.attachContent());
    } catch (_) { }
  }

  /**
   * å è½½æ°æ®è¡
   */
  protected _loadRows(): Observable<boolean> {
    if (
      (this.componentState === this.componentStateEnums.Loading) ||                 // æ­£å¨å è½½è¿ç¨ä¸­ä¸ä¼åæ¬¡è°ç¨åç«¯æ¥å£
      (this.componentState !== this.componentStateEnums.Initial && !this.total) ||  // æå¡å¨çº¦å®è¿åç©ºåè¡¨åä¸ä¼åæ¬¡å°è¯æåæ°æ®
      (this.total > 0 && this.loadedCount >= this.total) ||                       // å è½½çæ°æ®è¡å·²ç»è¾¾å°çº¦å®çè¡æ°ä¸ä¼åæ¬¡è°ç¨åç«¯æ¥å£
      (this.attachedItemEnd < this.loadedCount - 1)                               // å°æªæ»å¨å°é¡µé¢åºé¨ä¸ä¼è°ç¨åç«¯æ¥å£
    ) { return of(false); }

    // tslint:disable-next-line: one-variable-per-declaration
    let lineNumBegin = 0, lineNumEnd = 0;
    if (this.componentState === this.componentStateEnums.Initial) {
      this.excelRows = [];
      this.total = 0;
      this.loadedCount = 0;
      lineNumBegin = 0;
      // this.loading();
    } else {
      this.loading();
      // this.componentState = this.componentStateEnums.Loading;
      lineNumBegin = this.attachedItemEnd + 1;
    }
    lineNumEnd = lineNumBegin + 1;

    return this.controller.loadRows(lineNumBegin, lineNumEnd).pipe(
      map(({ excelRows, total }) => {
        if (this.componentState === this.componentStateEnums.Initial) {
          this.total = total;
        }
        if (this.excelRows.length >= this.total) {
          // Excelçè¡æ°å·²ç»è¾¾å°çº¦å®çè®°å½æ°éåä¸åå è½½æ°çæ°æ®è¡
          return;
        }

        let calculatedHeight = this.excelAnchorScrollRunwayEnd;
        excelRows.forEach((excelRow) => {
          const i = excelRow.i;
          excelRow.y = calculatedHeight;
          excelRow.h = this.customCalculateHeight ? this.customCalculateHeight(excelRow.context) : this.lineHeight;
          calculatedHeight += excelRow.h;
          if (this.loadedCount - 1 >= i) {
            this.excelRows.splice(i, 1, ...[excelRow]);
          } else {
            this.excelRows.push(excelRow);
            this.loadedCount++;
          }
          this.excelRowsReflection[excelRow.primaryKey] = i;
        });

        this.normal();
        this.excelAnchorScrollRunwayEnd = calculatedHeight;
        return true;
      }),
      catchError((e) => {
        this.normal();
        if (e) { this._getErrorHandles()(e); }
        return of(false);
      })
    );
  }

  /**
   * å½æ»å¨æ»å¨æ¡æ§è¡
   */
  private _handleScrollBarXScroll() {
    this.contextMenu.closeAllContextMenus(null);
    const radio = Math.ceil(this._el.offsetWidth / this._scrollBarXEl.offsetWidth);
    const scrollX = Math.ceil(this._scrollBarXEl.scrollLeft * radio);
    this._el.scrollLeft = scrollX;
  }

  /**
   * å½Excelæ»å¨æ¶æ§è¡
   */
  private _handleExcelScroll() {
    this.contextMenu.closeAllContextMenus(null);
    if (this._scrollBarXEl) {
      this._scrollBarXEl.scrollLeft = Math.ceil(this._el.scrollLeft * this._scrollBarXRatio);
    }
    // const delta = this.el.nativeElement.scrollTop - this.excelAnchorScrollTop;

    const excelHeight = parseInt(getComputedStyle(this.el.nativeElement, null).height, 10);
    const excelHeadHeight = this._headEl ? parseInt(getComputedStyle(this._headEl, null).height, 10) : 0;
    const excelFootHeight = this._footEl ? parseInt(getComputedStyle(this._footEl, null).height, 10) : 0;
    const height = excelHeight - excelHeadHeight - excelFootHeight;

    this.excelAnchorItem = { index: 0, offset: 0 };
    this.excelAnchorScrollTop = this._el.scrollTop;
    if (this.excelAnchorScrollTop > 0) {
      this.excelAnchorItem.index = this.excelRows.findIndex((excelRow) => this.excelAnchorScrollTop <= excelRow.y) - 1;
      this.excelAnchorItem.offset = this.excelAnchorScrollTop - this.excelRows[this.excelAnchorItem.index].y;
    } else {
      this.excelAnchorItem.index = 0;
      this.excelAnchorItem.offset = 0;
    }

    const lastScreenItem = { index: 0, offset: 0 };
    const nextRowIndex = this.excelRows.findIndex((excelRow) => excelRow.y >= this.excelAnchorScrollTop + height);
    if (nextRowIndex > 0) {
      lastScreenItem.index = nextRowIndex - 1;
      lastScreenItem.offset = this.excelAnchorScrollTop + height - this.excelRows[lastScreenItem.index].y;
    } else if (nextRowIndex === 0) {
      lastScreenItem.index = 0;
      lastScreenItem.offset = this.excelAnchorScrollTop + height;
    } else {
      lastScreenItem.index = this.excelRows.length;
      lastScreenItem.offset = 0;
    }
    this.excelScreenItem = lastScreenItem;
    this.attachedItemBegin = this.excelAnchorItem.index;
    this.attachedItemEnd = lastScreenItem.offset ? lastScreenItem.index : lastScreenItem.index - 1;
    this.attachContent();
  }


  /**
   * æ³¨åWindowå°ºå¯¸ååäºä»¶
   */
  private _listenWindowOnResize() {
    const windowReSizeSubscription = fromEvent(window, 'resize').pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(() => {
      this.contextMenu.closeAllContextMenus(null);
      this.rebuildUi();
    });
    this._componentSubscription.add(windowReSizeSubscription);
  }

  /**
   * æ³¨åExcelæ»å¨äºä»¶
   */
  private _listenExcelOnScroll() {
    const source = fromEvent(this._el, 'scroll').pipe(
      filter(() => !this._scrollBarXScrolling &&
        this.componentState !== this.componentStateEnums.Initial &&
        this.componentState !== this.componentStateEnums.Loading),
      share()
    );

    this._componentSubscription.add(
      source.pipe(debounceTime(200))
        .subscribe(() => this._excelScrolling = false)
    );

    this._componentSubscription.add(
      source
        .pipe(tap(() => this._excelScrolling = true))
        .subscribe(() => this._handleExcelScroll())
    );
  }


  /**
   * æ³¨åScrollBarXæ»å¨äºä»¶
   */
  private _listenScrollBarXOnScroll() {
    // èªå®ä¹æ¨¡æ¿è¡¨èæ²¡ææ¨ªåæ»å¨æ¡
    if (!this._scrollBarXEl) { return; }
    const source = fromEvent(this._scrollBarXEl, 'scroll').pipe(
      map((e: Event) => (e.target as HTMLElement).scrollLeft),
      distinctUntilChanged(),
      filter(() => !this._excelScrolling &&
        this.componentState !== this.componentStateEnums.Initial &&
        this.componentState !== this.componentStateEnums.Loading),
      share()
    );

    this._componentSubscription.add(
      source.pipe(debounceTime(200))
        .subscribe(() => this._scrollBarXScrolling = false)
    );

    this._componentSubscription.add(
      source
        .pipe(tap(() => this._scrollBarXScrolling = true))
        .subscribe(() => this._handleScrollBarXScroll())
    );
  }

  /**
   * æ³¨ååçäºä»¶çå¬
   */
  private _listenNativeEvents() {
    this._listenWindowOnResize();
    this._listenExcelOnScroll();
    this._listenScrollBarXOnScroll();
  }

  /**
   * è·å¾å·²éç½®çéèå
   */
  private _getInvisibleColumns(): string[] {
    if (!this.toggleColumnEnabled) { return []; }
    const cacheKey = this._cacheKey + 'InvisibleColumns';
    const invisibleColumnsJson = localStorage.getItem(cacheKey);
    return JSON.parse(invisibleColumnsJson || '[]');
  }

  /**
   * ä¿å­éèåéç½®
   */
  private _cacheInvisibleColumns() {
    if (!this.toggleColumnEnabled) { return; }
    const cacheKey = this._cacheKey + 'InvisibleColumns';
    const invisibleColumnsJson = JSON.stringify(this._invisibleColumns);
    localStorage.setItem(cacheKey, invisibleColumnsJson);
  }

  /**
   * è·å¾éè¯¯å¤çå½æ°
   */
  private _getErrorHandles() {
    return (e: any) => e && this.message.error(e.message || e);
  }

}
